import Cookies from 'js-cookie';

// Utility function to check and prompt for username
export const checkAndPromptForUsername = () => {
  let username = Cookies.get("username");
  if (!username) {
    // Generate a random hash for the username
    const randomHash = Math.random().toString(36).substring(2, 15) 
                      + Math.random().toString(36).substring(2, 15);
    Cookies.set("username", randomHash, { expires: 30 });
  }
  return Cookies.get("username"); // Return the username
};

// Utility function to add item to local storage
const addToLocalStorage = (mediaType, newItem) => {
  console.log('>>>> Adding to local storage:', newItem); 
  console.log(newItem);
  const normalizedType = mediaType === "movie" ? "movies" :
                         mediaType === "tv" ? "tv-shows" : mediaType;
  if (mediaType === "movie") {
    mediaType = "movies";
  } else if (mediaType === "tv") {
    mediaType = "tv-shows";
  }
  const key = `sortedWatchList-watchLater`;
  const storedList = localStorage.getItem(key);
  const watchList = storedList ? JSON.parse(storedList) : [];

  // Check if the item is already in the list
  const itemExists = watchList.some(item => item.tmdb_id === newItem.tmdb_id);

  if (!itemExists) {
    // Add the new item to the start of the list
    watchList.unshift(newItem);
    localStorage.setItem(key, JSON.stringify(watchList));
  }

  // Always add to the top picks list
  const topPickKey = `sortedWatchList-${normalizedType}`;
  const storedTopPicks = localStorage.getItem(topPickKey);
  const topPicksList = storedTopPicks ? JSON.parse(storedTopPicks) : [];

  // Remove any existing instance of the same item
  const updatedTopPicks = topPicksList.filter(item => item.tmdb_id !== newItem.tmdb_id);

  // Add the new item to the start of the list
  updatedTopPicks.unshift(newItem);

  // Save the updated top picks list
  localStorage.setItem(topPickKey, JSON.stringify(updatedTopPicks));

  const homepageEvent = new CustomEvent("watchlistUpdated", {
    detail: { mediaType: normalizedType }
  });
  window.dispatchEvent(homepageEvent);
  console.log(`>>>> Added to local storage under key: ${key} and ${topPickKey}`);
};

// Function to add item to watchlist
export const addToWatchlist = async (item, event, onRecommendationsFetched) => {
  event.preventDefault();
  event.stopPropagation();
  checkAndPromptForUsername();
  
  let username = Cookies.get("username");
  if (!username) {
    username = prompt("Please enter your email address for your watchlist:");
    if (!username) return; // Exit if no username is provided
    Cookies.set("username", username, { expires: 30 });
  }
 
  window.triggerWatchlistAnimation();
  let { id, title, media_type, tmdb_id } = item;
  // Add to local storage watchlist

  // This assumes you have a way to identify the closest relevant DOM element
  const targetElement = event.target.closest('.media-item');
  let response_data = null;
  if (tmdb_id !== undefined) {
    id = tmdb_id;
  }
    
  if (targetElement) {
    targetElement.style.opacity = '0'; // Start fade-out effect
    setTimeout(() => {
      // Hide the target element after the animation using display: none
      targetElement.style.display = 'none';
    }, 300); // Match the CSS animation duration
  }

  try {
    // Add to server watchlist
    const response = await fetch(`/w/${username}/add/${id}?title=${encodeURIComponent(title)}&media_type=${media_type}`, {
      method: 'GET'
    });
    response_data = await response.json();
    addToLocalStorage(media_type, response_data.response);

  } catch (error) {
    console.error('Error:', error);
  }
  return response_data;
};

const fetchAPI = async (url, options = {}) => {
  try {
    const response = await fetch(url, options);
    const data = await response.json();
    return [data, null];
  } catch (error) {
    console.error('Fetch error:', error);
    return [null, error];
  }
};

export { fetchAPI };


// --- Additional Utilities ---

export const TV_GENRES = {
  10759: "Action & Adventure", 16: "Animation", 35: "Comedy", 80: "Crime", 99: "Documentary",
  18: "Drama", 10751: "Family", 10762: "Kids", 9648: "Mystery", 10763: "News",
  10764: "Reality", 10765: "Sci-Fi & Fantasy", 10766: "Soap", 10767: "Talk", 10768: "War & Politics", 37: "Western"
};

export const MOVIE_GENRES = {
  28: "Action", 12: "Adventure", 16: "Animation", 35: "Comedy", 80: "Crime", 99: "Documentary",
  18: "Drama", 10751: "Family", 14: "Fantasy", 36: "History", 27: "Horror", 10402: "Music",
  9648: "Mystery", 10749: "Romance", 878: "Science Fiction", 10770: "TV Movie",
  53: "Thriller", 10752: "War", 37: "Western"
};

export const getGenreNames = (item, type) => {
  const genreMap = type === 'tv' ? TV_GENRES : MOVIE_GENRES;
  if (item.genre_ids) {
    return String(item.genre_ids)
      .split(',')
      .map(id => parseInt(id.trim(), 10))
      .map(id => genreMap[id])
      .filter(Boolean)
      .join(', ');
  }
  return item.genre || item.genres || '';
};

export const sortMediaList = (list, sortMode) => {
  const sorted = [...list];
  if (sortMode === 'rating') {
    sorted.sort((a, b) => (b.vote_average || 0) - (a.vote_average || 0));
  } else if (sortMode === 'recent') {
    sorted.sort((a, b) =>
      new Date(b.release_date || b.first_air_date || '') - new Date(a.release_date || a.first_air_date || '')
    );
  } else {
    sorted.sort((a, b) => (a.title || '').localeCompare(b.title || ''));
  }
  return sorted;
};

export const shuffleArray = (array) => {
  const shuffled = [...array];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
};

export const fetchDataForItems = async (visibleMedia, endpointPath, processData) => {
  const result = {};
  for (const type of ['tv', 'movies']) {
    for (const item of visibleMedia[type]) {
      try {
        const path = endpointPath.includes('?') 
          ? `${endpointPath}&tmdb_id=${item.tmdb_id}&media_type=${type}`
          : `${endpointPath}/${type}/${item.tmdb_id}`;
        const res = await fetch(path);
        const data = await res.json();
        const processed = processData(data);
        console.log(`[${type.toUpperCase()}] ${item.title} (${item.tmdb_id}) →`, processed);
        result[item.tmdb_id] = processed;
      } catch (e) {
        console.error(`Error fetching from ${endpointPath} for ${item.title}`, e);
      }
    }
  }
  return result;
};

// --- Additional Utility Functions ---

export const hasVisibleMedia = (visibleMedia) =>
  visibleMedia.tv.length > 0 || visibleMedia.movies.length > 0;

export const getTmdbLink = (item, type) => {
  if (item.tmdb_id) {
    return `https://www.themoviedb.org/${type}/${item.tmdb_id}/watch`;
  }
  return `https://www.themoviedb.org/search?query=${encodeURIComponent(item.title || '')}`;
};

export const handleDeleteItem = (tmdb_id, type, visibleMedia, setVisibleMedia, setDeletingItemId) => {
  setDeletingItemId(tmdb_id);
  setTimeout(() => {
    const updatedList = visibleMedia[type].filter(i => i.tmdb_id !== tmdb_id);
    const storageKey = `sortedWatchList-${type}`;
    const currentStored = JSON.parse(localStorage.getItem(storageKey) || '[]');
    const restoredList = currentStored.filter(stored => stored.tmdb_id !== tmdb_id);
    setVisibleMedia(prev => ({ ...prev, [type]: updatedList }));
    localStorage.setItem(storageKey, JSON.stringify(restoredList));
    setDeletingItemId(null);
  }, 400);
};
